import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';
import { MyDatePickerModule } from 'mydatepicker';
import { NgxPaginationModule } from 'ngx-pagination';
import { AppComponent } from './app.component';
import { AccordionComponent } from './core/components/accordion/accordion.component';
import { AlertComponent } from './core/components/alert/alert.component';
import { BaseComponent } from './core/components/base/base.component';
import { ChckboxComponent } from './core/components/chckbox/chckbox.component';
import { DashboardHomeComponent } from './core/components/dashboard-home/dashboard-home.component';
import { DatePickerComponent } from './core/components/date-picker/date-picker.component';
import { DropdownComponent } from './core/components/dropdown/dropdown.component';
import { EngineComponent } from './core/components/engine/engine.component';
import { HeaderToolbarComponent } from './core/components/header-toolbar/header-toolbar.component';
import { HeaderComponent } from './core/components/header/header.component';
import { LoaderComponent } from './core/components/loader/loader.component';
import { LogoHeaderComponent } from './core/components/logo-header/logo-header.component';
import { MainComponent } from './core/components/main-component/main.component';
import { MainNavbarComponent } from './core/components/main-navbar/main-navbar.component';
import { MenuBlocksComponent } from './core/components/menu-blocks/menu-blocks.component';
import { MenuButtonComponent } from './core/components/menu-button/menu-button.component';
import { ModalDialogComponent } from './core/components/modal-dialog/modal-dialog.component';
import { PageViewComponent } from './core/components/page-view/page-view.component';
import { PaginationComponent } from './core/components/pagination/pagination.component';
import { ProgressChartComponent } from './core/components/progress-chart/progress-chart.component';
import { SelectListComponent } from './core/components/select-list/select-list.component';
import { TableComponent } from './core/components/table/table.component';
import { TextareaComponent } from './core/components/textarea/textarea.component';
import { TextboxComponent } from './core/components/textbox/textbox.component';
import { TgButtonComponent } from './core/components/tg-button/tg-button.component';
import {
  CreateAutoTrainingCodeComponent
} from './core/components/training-management/create-auto-training-code/create-auto-training-code.component';
import {
  EditAutoTrainingCodeComponent
} from './core/components/training-management/edit-auto-training-code/edit-auto-training-code.component';
import { EmailInviteComponent } from './core/components/training-management/email-invite/email-invite.component';
import { EmailSentComponent } from './core/components/training-management/email-sent/email-sent.component';
import {
  InactiveAutoTrainingCodeComponent
} from './core/components/training-management/inactive-auto-training-code/inactive-auto-training-code.component';
import {
  ReportingTrainingComponent
} from './core/components/training-management/reporting-training/reporting-training-home/reporting-training-home.component';
import { ReportingComponent } from './core/components/training-management/reporting-training/reporting/reporting.component';
import {
  ScoreDetailsReportComponent
} from './core/components/training-management/reporting-training/score-details-report/score-details-report.component';
import {
  TrainingManagementHomeComponent
} from './core/components/training-management/training-management-home/training-management-home.component';
import {
  TrainingManagementComponent
} from './core/components/training-management/training-management/training-management.component';
import { UnitheaderComponent } from './core/components/unitheader/unitheader.component';

import { ChartsModule } from 'ng2-charts';
import { AppRoutingModule } from './app-routing.module';
import { DataAccordionComponent } from './core/components/data-accordion/data-accordion.component';
import { PieChartComponent } from './core/components/pie-chart/pie-chart.component';
import { PopUpComponent } from './core/components/pop-up/pop-up.component';
import { PopupTableComponent } from './core/components/popup-table/popup-table.component';
import { ProgressBarComponent } from './core/components/progress-bar/progress-bar.component';
import { SuperAdminAccessComponent } from './core/components/training-management/super-admin-access/super-admin-access.component';
import { SuperAdminComponent } from './core/components/training-management/super-admin/super-admin.component';
import { AppVersionPipe } from './core/pipes/app-version.pipe';
import { AccessibilityService } from './core/services/accessibility.service';
import { AuthGuardService } from './core/services/auth-guard.service';
import { CommunicationProxyService } from './core/services/communication-proxy.service';
import { CsvHelperService } from './core/services/csv-helper-service.service';
import { HttpService } from './core/services/http.service';
import { KeyboardService } from './core/services/keyboard.service';
import { LoginService } from './core/services/login.service';
import { SheetjsHelperService } from './core/services/sheetjs-helper.service';
import { StringTableService } from './core/services/string-table.service';

@NgModule({
  bootstrap: [AppComponent],
  declarations: [
    AppComponent,
    LogoHeaderComponent,
    LoaderComponent,
    TgButtonComponent,
    HeaderComponent,
    MainNavbarComponent,
    MenuBlocksComponent,
    EngineComponent,
    AccordionComponent,
    SelectListComponent,
    UnitheaderComponent,
    HeaderToolbarComponent,
    MainComponent,
    TextboxComponent,
    AlertComponent,
    DatePickerComponent,
    TableComponent,
    DropdownComponent,
    ChckboxComponent,
    ModalDialogComponent,
    PaginationComponent,
    PageViewComponent,
    TrainingManagementComponent,
    EmailInviteComponent,
    TextareaComponent,
    TrainingManagementHomeComponent,
    CreateAutoTrainingCodeComponent,
    EditAutoTrainingCodeComponent,
    EmailSentComponent,
    InactiveAutoTrainingCodeComponent,
    ReportingTrainingComponent,
    ReportingComponent,
    ScoreDetailsReportComponent,
    DataAccordionComponent,
    PieChartComponent,
    PopUpComponent,
    PopupTableComponent,
    ProgressBarComponent,
    SuperAdminComponent,
    SuperAdminAccessComponent,
    AppVersionPipe,
    MenuButtonComponent,
    DashboardHomeComponent,
    ProgressChartComponent
  ],

  imports: [
    BrowserModule,
    HttpModule,
    NgxPaginationModule,
    MyDatePickerModule,
    HttpClientModule,
    AppRoutingModule,
    ChartsModule
  ],

  providers: [
    LoginService,
    HttpService,
    StringTableService,
    AccessibilityService,
    CommunicationProxyService,
    AuthGuardService,
    KeyboardService,
    CsvHelperService,
    SheetjsHelperService
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/app.module.ts